import { render, staticRenderFns } from "./IconScroll.vue?vue&type=template&id=62b6a2f6&"
import script from "./IconScroll.vue?vue&type=script&lang=js&"
export * from "./IconScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports